<template>
  <div class="login-wrapper cool-border">
    <el-form
      :model="reset"
      class="login-info"
      ref="resetPasswordForm"
      label-width="140px"
    >
      <div class="login-info-title">
        Reset Password
      </div>
      <el-form-item
        style="margin-top: 96px"
        label="new password"
        :prop="'newPassword'"
        :rules="passwordRule('password')"
      >
        <el-input
          v-model="reset.newPassword"
          placeholder="Please input new passsword"
          show-password
          auto-complete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item
        style="margin-top: 36px"
        label="repeat password"
        :prop="'repeatPassword'"
        :rules="repeatPasswordRule('password', reset.newPassword)"
      >
        <el-input
          v-model="reset.repeatPassword"
          placeholder="Repeat your new passsword"
          show-password
          auto-complete="new-password"
        ></el-input>
      </el-form-item>
      <div class="login-info-option">
        <el-button class="login-info-option-login" @click="resetPassword()"
          >Submit</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MixFormRule from "@/components/mixins/formRule";
export default {
  name: "resetPassword",
  mixins: [MixFormRule],
  data() {
    return {
      reset: {
        newPassword: "",
        repeatPassword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      resetPasswordToServer: "user/resetPasswordToServer",
    }),
    async resetPassword() {
      try {
        let res = await this.$refs.resetPasswordForm.validate();
        let token = this.$route.query.token;
        let postData = { ...this.reset, token };
        await this.resetPasswordToServer(postData);
        Vue.prototype.$notify.success({
          title: "Success",
          message: "Success to reset password",
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
        const vm = this;
        setTimeout(function() {
          vm.$router.push("/login");
        }, 1000);
      } catch (e) {
        Vue.prototype.$notify.error({
          title: "Error",
          message: e.response.data.msg,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
  },
};
</script>
<style lang="sass" scoped>
@keyframes animatedgradient
  0%
    background-position: 0% 50%
  50%
    background-position: 100% 50%
  100%
    background-position: 0% 50%
.login-theme
  &-font
    color: rgb(64, 131, 237)
    font-weight: bold
    font-family: "Acumin Pro"

.login-wrapper
  .login-info
    width: 400px
    padding: 16px
    z-index: 1
    background: white
    &-switch
      font-size: 14px
      text-align: right
      display: flex
      justify-content: flex-end
      .pointer
        cursor: pointer
    &-title
      margin: 4px 0px 24px
      display: flex
      justify-content: center
      color: $color-blue
      font-size: 24px
    &-option
      margin-top: 12px
      display: flex
      justify-content: flex-end
      &-login
        width:100%
        background-color: $color-blue
        color: white
        margin-top: 30px
    ::v-deep .el-form-item__label
      text-align: left
    ::v-deep .el-form-item__error
      margin-left: 16px
  h1
    color: $color-blue
    text-align: center
  .btn
    position: relative
    display: block
    border: none
    cursor: pointer
    outline: none
    left: 50%
    transform: translateX(-50%)
  .login-btn
    font-size: 18px
    font-weight: 400
    color: $color-white
    background-color: $color-blue
    border-radius: 30px
    padding: 10px
    text-align: center
    width: 150px
    text-decoration: none
</style>
